<template>
  <section class="f-31">
    <div class="alive-content">
      <div class="alive-card f-select-center" v-ia>
        <div class="alive-card-content">
          <div class="title f-center-title">速度线</div>
          <div class="sub_title f-center-sub-title">
            光线将根据行驶速度、转弯方向动态穿梭、变化
          </div>
          <div class="sub_title f-center-sub-title">与你的每一次操控共鸣</div>
        </div>
        <m-video
          ref="video1"
          muted
          playsinline
          webkit-playsinline
          disablepictureinpicture
          src="@/v2/auto/assets/video/31/0.mp4"
        />
        <replay
          class="alive_replay"
          @click="() => replayVideo(this.$refs.video1)"
        />
      </div>
      <div class="alive-card f-select-center" v-ia>
        <div class="alive-card-content">
          <div class="title f-center-title">文字壁纸</div>
          <div class="sub_title f-center-sub-title">
            将你设置的汉字拆解、重构，以笔画的形态漂浮在屏幕
          </div>
          <div class="sub_title f-center-sub-title">里，尽显汉字之美</div>
        </div>
        <m-video
          ref="video2"
          muted
          playsinline
          webkit-playsinline
          disablepictureinpicture
          src="@/v2/auto/assets/video/31/1.mp4"
        />
        <replay
          class="alive_replay"
          @click="() => replayVideo(this.$refs.video2)"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { videoPlayByVisibleArea, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    this.videoRunner()
  },
  methods: {
    videoRunner() {
      const video1 = this.$refs.video1
      const video2 = this.$refs.video2
      video1 && videoPlayByVisibleArea(video1, 0.3)
      video2 && videoPlayByVisibleArea(video2, 0.6)
    },
    replayVideo,
  },
}
</script>
<style lang="less" scoped>
.f-31 {
  width: 100%;
  position: sticky;
  background-color: black;
  margin-top: -5px;

  .alive-content {
    padding: 50px 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;

    .alive-card {
      height: min-content;
      position: relative;
      overflow: hidden;

      video {
        border-radius: 20px;
        width: 100%;
        height: 100%;
      }

      .alive-card-content {
        position: absolute;
        z-index: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        margin-left: 10%;
        color: white;

        .title {
          font-weight: 600;
          line-height: 1.5;
          margin-bottom: 24px;
        }

        .sub_title {
          font-weight: 300;
          line-height: 1.5;
        }
      }
      .alive_replay {
        position: absolute;
        z-index: 1;
        bottom: 20px;
        right: 24px;
        color: white;
      }
    }
  }
}
</style>
